import React from 'react'
import AddIco from "../../images/AddIco.svg"

function InfoPopup({ show, onMainButtonClick, onSecondaryButtonClick, onClose, title, mainButtonText, secondaryButtonText, children}) {
    
    if(show){
        return (
            <div className='info-popup_backdrop' >
                <div className="info-popup">
                    <div className='info-popup__header'>
                        <button className='info-popup__close-button' onClick={onClose}><img src={AddIco} alt="закрыть" className='info-popup__close-button-icon'/></button>
                    </div>
                    <div className='info-popup__main-container'>
                        <h2 className='info-popup__title'>{title}</h2>
                        <p className='info-popup__text'>{children}</p>
                    </div>
                    <div className='info-popup__footer'>
                        {
                            onMainButtonClick&&
                            <button onClick={onMainButtonClick} className='info-popup__button info-popup__main-button'>{mainButtonText}</button>
                        }
                        {
                            onSecondaryButtonClick&&
                            <button onClick={onSecondaryButtonClick} className='info-popup__button info-popup__secondary-button'>{secondaryButtonText}</button>
                        }
                    </div>
                </div>
            </div>
        )
    }
    
}

export default InfoPopup